import { StandardEvents } from '@shopify/events';

// Reuse Horizon's resolved selection, including its request cancellation and locale handling.
class MMProductDetails extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.onSelection);
  }
  disconnectedCallback() { this.section?.removeEventListener(StandardEvents.productSelect, this.onSelection); }
  onSelection = (event) => {
    if (event.target.closest('product-card')) return;
    event.promise.then(({detail}) => {
      if (!this.isConnected || !detail?.html) return;
      if (!detail.newProduct && detail.productId !== this.dataset.productId) return;
      const fresh = [...detail.html.querySelectorAll('mm-product-details')].find(x => x.dataset.blockId === this.dataset.blockId);
      if (!fresh) return;
      const opened = [...this.querySelectorAll('details')].map(x => x.open);
      this.innerHTML = fresh.innerHTML;
      this.dataset.productId = fresh.dataset.productId;
      this.querySelectorAll('details').forEach((x, i) => { if (opened[i] !== undefined) x.open = opened[i]; });
    }).catch(() => { /* Horizon exposes selection failures in the purchase form. */ });
  };
}
if (!customElements.get('mm-product-details')) customElements.define('mm-product-details', MMProductDetails);

document.addEventListener('click', event => {
  const button = event.target.closest('[data-mm-expand]');
  if (!button) return;
  const fieldset = document.getElementById(button.getAttribute('aria-controls'));
  if (!fieldset) return;
  const expanded = button.getAttribute('aria-expanded') !== 'true';
  fieldset.toggleAttribute('data-mm-expanded', expanded);
  button.setAttribute('aria-expanded', String(expanded));
  button.textContent = expanded ? button.dataset.less : button.dataset.more;
});
